import * as api from "services/api";
import { getErrors } from "helpers/error";
import { Callback } from "Types/Callback";
import INFSe from "Types/INFSe";
import { State } from "store/reducers";

export const CREATE_NFSE = "[NFSE CREATE] CREATE_NFSE";
export const CREATE_NFSE_SUCCESS = "[NFSE CREATE] CREATE_NFSE_SUCCESS";
export const CREATE_NFSE_FAILED = "[NFSE CREATE] CREATE_NFSE_FAILED";

export const SET_VALUE = "[NFSE CREATE] SET_VALUE";
export const CLEAR_VALUES = "[NFSE CREATE] CLEAR_VALUES";

export function setValue(payload: any) {
	return { type: SET_VALUE, payload };
}

export function clearValues() {
	return { type: CLEAR_VALUES };
}

export function createNFSe(callback: Callback<INFSe>) {
	return async (dispatch: any, getState: any) => {
		dispatch({ type: CREATE_NFSE });

		try {
			const { login, bankBilletCreate } = getState() as State;

			const {} = bankBilletCreate;

			const errors: any = {};

			dispatch(setValue({ errors }));

			if (Object.keys(errors).length)
				return dispatch({ type: SET_VALUE, payload: { loading: false } });

			const model = {};

			const response = await api.sendPost("/NFSe", model, {
				Authorization: `Bearer ${login.token}`
			});

			if (response.ok) {
				dispatch({
					type: CREATE_NFSE_SUCCESS
				});

				callback && callback();
			} else {
				const result = await response.json();

				const errors = getErrors(result.errors);

				dispatch({
					type: CREATE_NFSE_FAILED,
					payload: errors
				});
				callback && callback(errors);
			}
		} catch (error) {
			callback && callback(error);

			return dispatch({
				type: CREATE_NFSE_FAILED,
				payload: {
					error: "Connection error"
				}
			});
		}
	};
}
